import {
  FETCH_PROMO_CODES_DATA,
  FETCH_PROMO_CODES_SUCCESS,
  FETCH_PROMO_CODES_FAILURE,
  FETCH_PROMO_CODES_EDIT_DATA,
  FETCH_PROMO_CODES_EDIT_SUCCESS,
  FETCH_PROMO_CODES_EDIT_FAILURE,
} from "./actionTypes";

export const fetchPromoCodesData = () => ({
  type: FETCH_PROMO_CODES_DATA,
});

export const fetchPromoCodesSuccess = (data) => ({
  type: FETCH_PROMO_CODES_SUCCESS,
  payload: data,
});

export const fetchPromoCodesFailure = (error) => ({
  type: FETCH_PROMO_CODES_FAILURE,
  payload: error,
});

export const fetchPromoCodesEditData = (id) => ({
  type: FETCH_PROMO_CODES_EDIT_DATA,
  payload: id,
});

export const fetchPromoCodesEditSuccess = (data) => ({
  type: FETCH_PROMO_CODES_EDIT_SUCCESS,
  payload: data,
});

export const fetchPromoCodesEditFailure = (error) => ({
  type: FETCH_PROMO_CODES_EDIT_FAILURE,
  payload: error,
});
